import React from 'react';
import { Card, CardContent, Box, Typography, Avatar } from '@mui/material';
import { TrendingUp, TrendingDown } from '@mui/icons-material';

const StatCard = ({ title, value, icon, color = 'primary', trend, trendValue, subtitle }) => {
  const colorMap = {
    primary: { bg: '#e8eaf6', icon: '#1a237e' },
    success: { bg: '#e8f5e9', icon: '#2e7d32' },
    warning: { bg: '#fff3e0', icon: '#f57c00' },
    error: { bg: '#ffebee', icon: '#c62828' },
    info: { bg: '#e3f2fd', icon: '#1565c0' },
  };
  const colors = colorMap[color] || colorMap.primary;

  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
          <Box>
            <Typography variant="body2" color="text.secondary" fontWeight={500} gutterBottom>
              {title}
            </Typography>
            <Typography variant="h4" fontWeight={700} sx={{ mb: 0.5 }}>{value}</Typography>
            {subtitle && <Typography variant="caption" color="text.secondary">{subtitle}</Typography>}
            {trend !== undefined && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5 }}>
                {trend >= 0 ? (
                  <TrendingUp sx={{ fontSize: 16, color: 'success.main' }} />
                ) : (
                  <TrendingDown sx={{ fontSize: 16, color: 'error.main' }} />
                )}
                <Typography variant="caption" color={trend >= 0 ? 'success.main' : 'error.main'} fontWeight={600}>
                  {Math.abs(trendValue || trend)}% vs last month
                </Typography>
              </Box>
            )}
          </Box>
          <Avatar sx={{ bgcolor: colors.bg, width: 52, height: 52, borderRadius: 2 }}>
            <Box sx={{ color: colors.icon, display: 'flex' }}>{icon}</Box>
          </Avatar>
        </Box>
      </CardContent>
    </Card>
  );
};

export default StatCard;
